import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';

const propTypes = {
  autoCapitalize: PropTypes.string,
  autoCorrect: PropTypes.string,
  autoFocus: PropTypes.bool,
  background: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.number,
  hideTitle: PropTypes.bool,
  iconSize: PropTypes.number,
  inputClassName: PropTypes.string,
  isCompactLayout: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  placeholderColor: PropTypes.string,
  postIcon: PropTypes.string,
  preIcon: PropTypes.string,
  selectionBackground: PropTypes.string,
  selectionColor: PropTypes.string,
  showClearFieldIcon: PropTypes.bool,
  showPostIcon: PropTypes.bool,
  showPreIcon: PropTypes.bool,
  spellcheck: PropTypes.bool,
  textColor: PropTypes.string,
  titleColor: PropTypes.string,
  titleFontSize: PropTypes.number,
  titleText: PropTypes.string,
  type: PropTypes.oneOf(['text', 'password', 'email']),
  value: PropTypes.string,
  width: PropTypes.number
};

const defaultProps = {
  titleText: 'Your Email',
  type: 'text',
  width: 300,
  titleColor: 'white',
  background: 'transparent',
  selectionColor: '#b6cce6',
  selectionBackground: '#001824',
  textColor: '#60A0E0',
  hideTitle: false,
  showPreIcon: false,
  showPostIcon: false,
  isCompactLayout: true,
  spellcheck: true,
  titleFontSize: 14,
  fontSize: 14,
  autoCorrect: 'off',
  autoCapitalize: 'none',
  placeholder: null,
  placeholderColor: 'red',
  showClearFieldIcon: false,
  autoFocus: false,
  className: '',
  isDisabled: false,
  inputClassName: ''
};

class TextInputWithLabel extends Component {
  state = {
    isActive: false,
    showPassword: false
  };

  componentDidMount () {
    this.setState({
      isActive: this.props.placeholder !== null || this.props.value.length > 0 || this.props.autoFocus
    });
  }

  componentDidUpdate(prvProps) {
    if (prvProps.value !== this.props.value && this.props.value.length > 0) {
      this.setState({ isActive: true });
    }
  }

  handleOnFocus = () => {
    this.setState({ isActive: true });
  };

  handleOnBlur = () => {
    if (this.props.placeholder === null && this.props.value.length === 0) {
      this.setState({ isActive: false });
    }
  };

  titleLabel = React.createRef();
  titleInput = React.createRef();

  render () {
    const { isActive, showPassword } = this.state;
    const {
      type,
      hideTitle,
      isCompactLayout,
      showPreIcon,
      preIcon,
      showPostIcon,
      postIcon,
      showClearFieldIcon,
      titleFontSize,
      fontSize,
      className,
      isDisabled,
      inputClassName
    } = this.props;

    const styles = StyleSheet.create({
      titleInputContainer: {
        borderBottom: `1px solid ${this.props.titleColor}`,
        width: `${this.props.width}px`,
        height: hideTitle ? '27px' : '43px'
      },
      titleInputLabel: {
        position: 'relative',
        paddingLeft: '5px',
        fontSize: `${titleFontSize}px`,
        top: hideTitle ? '0px' : '18px',
        color: this.props.titleColor,
        transition: 'all 0.1s linear',
        height: '20px'
      },
      titleInput: {
        border: 0,
        width: `${this.props.width}px`,
        marginTop: '-2px',
        paddingLeft: '4px',
        paddingBottom: '5px',
        background: this.props.background,
        color: this.props.textColor,
        fontSize: `${fontSize}px`,
        caretColor: this.props.textColor,
        ':focus': {
          outline: 'none',
          fontSize: `${fontSize}px`,
        },
        '::selection': {
          color: this.props.selectionColor,
          background: this.props.selectionBackground,
          caretColor: this.props.selectionColor
        },
        '::placeholder': {
          // color: '#b14f00'
          color: this.props.placeholderColor
        }
      },
      active: {
        top: !isCompactLayout ? '0px' : '4px',
        fontSize: '12px'
      },
      hideTitle: {
        display: 'none'
      }
    });

    return (
      <div
        className={`${className} ${css(styles.titleInputContainer)}`}
        onClick={(e) => {
          if (!this.props.isDisabled && this.props.onClick) {
            this.props.onClick(e);
          }
        }}
      >
         <div
          ref={this.titleLabel}
          className={css(
            styles.titleInputLabel,
            isActive && styles.active,
            hideTitle && isActive && styles.hideTitle
          )}
          style={{ paddingLeft: isCompactLayout ? '4px' : '23px' }}
          onClick={() => {
            if (!isDisabled) {
              this.titleInput.current.focus();
            }
          }}
        >
          {this.props.titleText}
        </div>
        <div className="fx">
          {/* Pre icon */}
          {showPreIcon ? <i className={preIcon} style={{ fontSize: `${this.props.iconSize}px` }} /> : null}
          <input
            ref={this.titleInput}
            autoFocus={this.props.autoFocus}
            type={ !showPassword ? type : 'text' }
            className={`${inputClassName} ${css(styles.titleInput)}`}
            spellCheck={this.props.spellcheck ? 'true' : 'false'}
            value={this.props.value}
            autoCorrect={this.props.autoCorrect}
            autoCapitalize={this.props.autoCapitalize}
            onChange={this.props.onChange}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            placeholder={this.props.placeholder || ''}
            disabled={isDisabled}
          />
          {/* Post icon */}
          {showPostIcon
            ? <i
                className={postIcon}
                style={{ cursor: 'pointer', fontSize: `${this.props.iconSize}px` }}
                onClick={() => { this.setState({ showPassword: !showPassword }); }}
              />
            : null
          }
          {showClearFieldIcon && this.props.value.length > 0
            ? <i
                className='fa fa-times'
                style={{ cursor: 'pointer', fontSize: `${this.props.iconSize}px` }}
                onClick={() => {
                  this.props.onChange({ target: { value: '' } });
                  // if (this.titleInput && this.titleInput.current) {
                  //   this.titleInput.current.value = '';
                  // }
                }}
              />
            : null
          }
        </div>
      </div>
    );
  }
}

TextInputWithLabel.propTypes = propTypes;
TextInputWithLabel.defaultProps = defaultProps;
export { TextInputWithLabel };
